import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'characterLimitSanitize'
})
export class CharacterLimitSanitizePipe implements PipeTransform {

  transform(value: any, noOfCharacter: number): any 
  {
     value = value.changingThisBreaksApplicationSecurity;
     if(value == null)
     	return;
     if(value.length<=noOfCharacter)
     	return value;
     return value.substring(0,noOfCharacter-1)+"...";
  }

}
